import React,{ useState, useEffect, useRef } from 'react';
import { downloadCsv } from '../common/sharedFunctions';
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import moment from 'moment/min/moment-with-locales';
import { makeStyles } from '@mui/styles';
import {
  Modal,
  Grid,
  Typography,
  Box,
  Avatar,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {colors} from '../components/Theme/WebTheme';
import Button from "components/CustomButtons/Button.js";
import CancelIcon from '@mui/icons-material/Cancel';
import AlertDialog from '../components/AlertDialog';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import { Autocomplete, Chip } from '@mui/material';
import { modernTableStyle, modernTableOptions, MercosulPlateBadge } from '../common/tableTheme';
import UserCreateDialog from '../components/UserCreateDialog';

const useStyles = makeStyles((theme) => ({
  heading:{
    marginBottom:20,
    height:'10%'
  },
  submit1: {
    marginLeft: 16 
  },
  submit: {
    backgroundColor: '#2563eb',
    color: '#fff',
    borderRadius: '8px'
  },
  submit5: {
    backgroundColor: '#0f172a',
    color: '#fff',
    borderRadius: '8px'
  },
  submit3:{
    width:'100%',
    borderRadius: '10px',
    marginTop: 12,
    padding: '10px 16px',
    backgroundColor: '#2563eb',
    color: '#ffffff',
    fontWeight: 600,
    textTransform: 'none'
  },
  modal: {
    display: 'flex',
    padding: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: 480,
    maxWidth: '92vw',
    backgroundColor: '#ffffff',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
    padding: theme.spacing(3),
    borderRadius: '16px',
    border: '1px solid #e2e8f0',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none'
  },
  submit4:{
    backgroundColor: '#dc2626',
    color: '#fff',
    width:'100%',
    borderRadius: '10px',
    marginTop: 12,
    padding: '10px 16px',
    textTransform: 'none',
    fontWeight: 600
  }
}));

export default function Users() {
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    addUser,
    editUser, 
    deleteUser,
    checkUserExists,
    fetchUsersOnce,
    updateLicenseImage
  } = api;
  const [data, setData] = useState([]);
  const [cars, setCars] = useState({});
  const staticusers = useSelector(state => state.usersdata.staticusers || state.usersdata.users);
  const cartypes = useSelector(state => state.cartypes);
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const dispatch = useDispatch();
  const loaded = useRef(false);
  const classes = useStyles();
  const rootRef = useRef(null);
  const [role, setRole] = useState(null);
  const [fleetAdmins,setFleetAdmins] = useState([]);
  const [fleetAdminsObj, setFleetAdminsObj] = useState();

  // Estados para modal de edição e exclusão
  const [editingUser, setEditingUser] = useState(null);
  const [deleteConfirmUser, setDeleteConfirmUser] = useState(null);

  useEffect(()=>{
      dispatch(fetchUsersOnce());
  },[dispatch,fetchUsersOnce]);

  useEffect(()=>{
    if(staticusers && Array.isArray(staticusers)){
      const profile = auth?.profile;
      const tId = profile?.tenant_id || profile?.tenantId;
      const isSuper = Boolean(
        profile?.is_superadmin || 
        profile?.role === 'superadmin' || 
        profile?.usertype === 'superadmin' ||
        profile?.usertype === 'admin'
      );

      let arr = staticusers.filter(user => user.usertype === 'fleetadmin');
      let obj = {}; 
      let arr2 = [];
      for(let i = 0; i < arr.length; i++){
        let user = arr[i];
        arr2.push({id: user.id, desc: user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden")});
        obj[user.id] = user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden");
      }
      setFleetAdmins(arr2);
      setFleetAdminsObj(obj);

      const filtered = staticusers.filter(user => {
        const isDriver = user.usertype === 'driver' || user.role === 'driver';
        if (!isDriver) return false;
        if (isSuper) return true;
        const userTid = user.tenant_id || user.tenantId;
        if (tId && userTid) {
          return userTid === tId;
        }
        if (profile?.uid && user.fleetadmin) {
          return user.fleetadmin === profile.uid;
        }
        return !tId && !userTid;
      });
      setData(filtered);
    }else{
      setData([]);
    }
    loaded.current = true;
  },[staticusers, auth.profile, settings.AllowCriticalEditsAdmin, role]);

  useEffect(() => {
    if(auth.profile && auth.profile.usertype){
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  useEffect(()=>{
    if(cartypes.cars){
        let obj =  {};
        cartypes.cars.map((car)=> obj[car.name]=car.name)
        setCars(obj);
    }
  },[cartypes.cars]);

  const [imageType, setImageType] = useState(null);

  const onClick = (rowData,text) => {
     if(text === 'licenseImage'){
      setImageType(text);
      setImageData(rowData.licenseImage || rowData.license_image);
    }
    else if(text === 'licenseImageBack'){
      setImageType(text);
      setImageData(rowData.licenseImageBack || rowData.license_image_back);
    }
    else if(text === 'verifyIdImage'){
      setImageType(text);
      setImageData(rowData.verifyIdImage || rowData.verify_id_image);
    }
    setProfileModal(true);
    setUserData(rowData);
  };

  const columns = [
      { 
        title: 'Condutor / Motorista', 
        field: 'firstName',
        render: rowData => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Avatar 
              src={rowData.profile_image} 
              sx={{ width: 40, height: 40, bgcolor: '#0284c7', fontSize: '0.875rem', fontWeight: 700 }}
            >
              {rowData.firstName?.[0] || 'M'}
            </Avatar>
            <Box>
              <Typography sx={{ fontWeight: 600, color: '#0f172a', fontSize: '0.875rem', lineHeight: 1.2 }}>
                {rowData.firstName} {rowData.lastName}
              </Typography>
              <Typography sx={{ fontSize: '0.75rem', color: '#64748b' }}>
                {rowData.mobile || rowData.email || 'Sem contato'}
              </Typography>
            </Box>
          </Box>
        )
      },
      { 
        title: 'CNH / Categoria', 
        field: 'cnh',
        render: rowData => (
          <Box>
            <Typography sx={{ fontWeight: 600, color: '#1e293b', fontSize: '0.8125rem' }}>
              {rowData.cnh || '—'}
            </Typography>
            {rowData.cnh_category && (
              <Chip
                size="small"
                label={`Cat. ${rowData.cnh_category}`}
                sx={{ height: 20, fontSize: '0.6875rem', fontWeight: 600, bgcolor: '#f1f5f9', color: '#475569' }}
              />
            )}
          </Box>
        )
      },
      { 
        title: t('vehicle_model_name') || 'Veículo', 
        field: 'vehicleMake',
        render: rowData => (
          <div>
            <div style={{ fontWeight: 600, color: '#0f172a' }}>{rowData.vehicleMake} {rowData.vehicleModel}</div>
            <div style={{ fontSize: '0.75rem', color: '#64748b' }}>{rowData.carType}</div>
          </div>
        )
      },
      { 
        title: t('vehicle_reg_no') || 'Placa', 
        field: 'vehicleNumber',
        render: rowData => <MercosulPlateBadge plate={rowData.vehicleNumber} />,
        cellStyle: { textAlign: 'center' }
      },
      { 
        title: t('account_approve') || 'Status Cadastro', 
        field: 'approved', 
        type:'boolean', 
        render: rowData => (
          <Chip
            size="small"
            label={rowData.approved ? 'Homologado' : 'Em Análise'}
            sx={{
              bgcolor: rowData.approved ? '#eff6ff' : '#fef3c7',
              color: rowData.approved ? '#1d4ed8' : '#b45309',
              fontWeight: 700,
              fontSize: '0.75rem',
              borderRadius: '6px'
            }}
          />
        )
      },
      { 
        title: t('driver_active') || 'Disponibilidade',  
        field: 'driverActiveStatus', 
        type:'boolean', 
        render: rowData => (
          <Chip
            size="small"
            label={rowData.driverActiveStatus ? 'Disponível' : 'Indisponível'}
            sx={{
              bgcolor: rowData.driverActiveStatus ? '#dcfce7' : '#f1f5f9',
              color: rowData.driverActiveStatus ? '#15803d' : '#64748b',
              fontWeight: 700,
              fontSize: '0.75rem',
              borderRadius: '6px'
            }}
          />
        )
      },
      { 
        title: t('license_image_front') || 'CNH Frente', 
        field: 'licenseImage', 
        cellStyle:{ textAlign: 'center'},
        render: rowData => (rowData.licenseImage || rowData.license_image) ? (
          <button 
            onClick={()=>{onClick(rowData,'licenseImage')}} 
            style={{ border: '1px solid #e2e8f0', borderRadius: '6px', padding: 2, background: '#fff', cursor: 'pointer' }}
          >
            <img alt='License' src={rowData.licenseImage || rowData.license_image} style={{width: 50, height: 32, objectFit: 'cover', borderRadius: '4px'}}/>
          </button>
        ) : <span style={{ color: '#94a3b8', fontSize: '0.75rem' }}>—</span>
      },
      { 
        title: t('license_image_back') || 'CNH Verso', 
        field: 'licenseImageBack', 
        cellStyle:{ textAlign: 'center'},
        render: rowData => (rowData.licenseImageBack || rowData.license_image_back) ? (
          <button 
            onClick={()=>{onClick(rowData,'licenseImageBack')}} 
            style={{ border: '1px solid #e2e8f0', borderRadius: '6px', padding: 2, background: '#fff', cursor: 'pointer' }}
          >
            <img alt='License' src={rowData.licenseImageBack || rowData.license_image_back} style={{width: 50, height: 32, objectFit: 'cover', borderRadius: '4px'}}/>
          </button>
        ) : <span style={{ color: '#94a3b8', fontSize: '0.75rem' }}>—</span>
      },
      {
        title: 'Ações',
        field: 'actions',
        cellStyle: { textAlign: 'center', width: 110 },
        headerStyle: { textAlign: 'center', width: 110 },
        render: rowData => (
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
            <Tooltip title="Editar Motorista">
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  setEditingUser(rowData);
                }}
                sx={{
                  color: '#0284c7',
                  bgcolor: '#f0f9ff',
                  border: '1px solid #bae6fd',
                  '&:hover': { bgcolor: '#e0f2fe' }
                }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Excluir Motorista">
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  setDeleteConfirmUser(rowData);
                }}
                sx={{
                  color: '#ef4444',
                  bgcolor: '#fef2f2',
                  border: '1px solid #fecaca',
                  '&:hover': { bgcolor: '#fee2e2' }
                }}
              >
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        )
      }
  ];

  const [profileModal, setProfileModal] =  useState(false);
  const [imageData, setImageData] =  useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [loading, setLoading] = useState(false);

  const [selectedImage, setSelectedImage] = useState(null); 
  const handleProfileModal = (e) => {
    setProfileModal(false);
    setSelectedImage(null);
  }

  const [userData, setUserData] = useState();

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const handleSetProfileModal = (e) =>{
    e.preventDefault();
      if(selectedImage){
        setLoading(true);
        dispatch(updateLicenseImage(userData.id, selectedImage, imageType));
        setProfileModal(false); 
        setSelectedImage(null);
        setTimeout(()=>{
          setLoading(false); 
          dispatch(fetchUsersOnce());
        },10000);
      }
      else{
        setCommonAlert({ open: true, msg: t('choose_image_first') })
      }
  }

  const [selectedRow, setSelectedRow] = useState(null);

  return (
    !loaded.current? <CircularLoading/>:
    <div>
    <MaterialTable
      title=""
      columns={columns}
      style={modernTableStyle}
      data={data}
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
      options={modernTableOptions(selectedRow, {
        searchPlaceholder: "Buscar motorista, placa, telefone...",
        maxBodyHeight: "calc(100vh - 280px)"
      })}
      localization={{body:{
        addTooltip: (t('add')),
        deleteTooltip: (t('delete')),
        editTooltip: (t('edit')),
        emptyDataSourceMessage: (
          (t('blank_message'))
      ),
      editRow: { 
        deleteText: (t('delete_message')),
        cancelTooltip: (t('cancel')),
        saveTooltip: (t('save')) 
          }, 
        },
        toolbar: {
          searchPlaceholder: (t('search')),
          exportTitle: (t('export')),
        },
        header: {
          actions: (t('actions')) 
      },
      pagination: {
        labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
        firstTooltip: (t('first_page_tooltip')),
        previousTooltip: (t('previous_page_tooltip')),
        nextTooltip: (t('next_page_tooltip')),
        lastTooltip: (t('last_page_tooltip'))
      },
      }}
    />
      {/* Modal Unificado de Edição de Condutor */}
      <UserCreateDialog
        open={Boolean(editingUser)}
        userToEdit={editingUser}
        onClose={() => setEditingUser(null)}
        onSuccess={() => {
          setEditingUser(null);
          dispatch(fetchUsersOnce());
        }}
        defaultRole="driver"
      />

      {/* Diálogo de Confirmação de Exclusão */}
      <Dialog
        open={Boolean(deleteConfirmUser)}
        onClose={() => setDeleteConfirmUser(null)}
        PaperProps={{ sx: { borderRadius: '16px', p: 1, maxWidth: 440 } }}
      >
        <DialogTitle sx={{ fontWeight: 700, color: '#0f172a' }}>
          Excluir Condutor?
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: '#475569' }}>
            Deseja realmente remover o cadastro de <strong>{deleteConfirmUser?.firstName} {deleteConfirmUser?.lastName}</strong>? Esta ação excluirá os dados operacionais do condutor.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button onClick={() => setDeleteConfirmUser(null)} sx={{ color: '#64748b' }}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="danger"
            onClick={() => {
              if (deleteConfirmUser?.id) {
                dispatch(deleteUser(deleteConfirmUser.id));
                setDeleteConfirmUser(null);
                setTimeout(() => dispatch(fetchUsersOnce()), 600);
              }
            }}
            sx={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600 }}
          >
            Excluir
          </Button>
        </DialogActions>
      </Dialog>
     <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={profileModal}
        onClose={handleProfileModal}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={1} className={classes.paper} style={{direction:isRTL==='rtl'?'rtl':'ltr'}}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography component="h1" variant="h6">
                      {t('license_image')}
                      <input
                          type="file"
                          style={{marginLeft:10}}
                          name= {t('image')}
                          onChange={(event) => {
                              setSelectedImage(event.target.files[0]);
                          }}
                      />
                </Typography>
              </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {selectedImage  && !loading ? 
                    <Tooltip title={t('cancel')}>
                      <CancelIcon onClick={()=>setSelectedImage(null)} style={{ fontSize: 30,backgroundColor:'red',borderRadius:50,color:"white" }}  />
                    </Tooltip>
                  : null }
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    {selectedImage ? 
                      <img alt="not fount" height={"200px"} src={URL.createObjectURL(selectedImage)} style={{marginTop:15,marginBottom:20}}/>
                    :
                      <img alt="licimage" height={"200px"} src={imageData} style={{marginTop:10}}/>
                    }
                    <br />
                  </Grid>
                
          <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
            {loading ? 
            <Grid
              container
              spacing={0}
              alignItems="center"
              justify="center"
              style={{ minHeight: '5vh' }} >
              <CircularProgress/>
            </Grid>
            :
            <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
            <Button onClick={handleProfileModal} variant="contained" color="danger">
            {t('cancel')}
          </Button> 
            <Button onClick={handleSetProfileModal} variant="contained" color="secondaryButton" style={{marginLeft:10}}>
              {t('save')}
            </Button>
            </Grid>
            }
          </Grid>
        </Grid>
      </Modal>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
      </div>
  );
}
